import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  ADD_LPN_TO_WANTED,
  CREATE_ROLE,
  CREATE_USER,
  DELETE_FROM_WANTED,
  DELETE_ROLE,
  DELETE_USER,
  LOAD_EXPORT,
  LOAD_PRESETS,
  LOAD_ROLE_LIST,
  LOAD_USER_LIST,
  LOAD_WANTED_LIST,
  SAVE_PRESET,
  SAVE_ROLE,
  SAVE_USER,
  SET_COMPASS,
  SET_GPS_MOD,
  IMPORT_LPN_FILE,
  LOAD_CAMERAS,
  CREATE_CAMERA,
  SAVE_CAMERA,
  DELETE_CAMERA,
  UPDATE_CAMERA,
  LOAD_WHITE_LIST,
  ADD_TO_WHITE_LIST,
  DELETE_FROM_WHITE_LIST,
  IMPORT_WHITE_LIST,
  LOAD_VIOLATION_LIST,
  ADD_TO_VIOLATION_LIST,
  DELETE_FROM_VIOLATION_LIST,
  IMPORT_VIOLATION_LIST,
  DELETE_PRESET,
  CREATE_PRESET,
  LOAD_PRESETS_COLLAGE,
  LOAD_USER_ACTION,
  CALIBRATE_CAMERA,
  GET_DEFAULT_COLLAGE,
  LOAD_DATE_SETTINGS,
  SAVE_ARCHIVE_SETTINGS,
  SAVE_DATE_SETTINGS,
  LOAD_ARCHIVE_SETTINGS,
  LOAD_ANALYSTS_SETTINGS,
  SAVE_ANALYSTS_SETTINGS, LOAD_DATE_STATUS, LOAD_GENERAL_SETTINGS,
  SAVE_GENERAL_SETTINGS,
  SAVE_EXPORT,
  UPDATE_EXPORT,
} from './actions';
import { SETTINGS_MODULE } from '../../configs/moduleNames';
import {
  createLoadParameterReducer,
  createOperationStateReducer, createOperationStateReducerWithBegin,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';
import SettingsDTO from '../../dto/SettingsDTO';

const initialState = {
  loadingSetCompass: false,
  loadingSetGpsMod: false,
  list: [],
  loadingPresetsList: false,
  presetsList: [],
  loadingSavePreset: false,
  loadingAddPreset: false,
  loadingDeletePreset: false,
  loadingExportList: false,
  exportList: [],
  loadingUserList: false,
  userList: [],
  loadingRoleList: false,
  roleList: [],
  loadingCreateRole: false,
  loadingSaveRole: false,
  loadingDeleteRole: false,
  loadingCreateUser: false,
  loadingSaveUser: false,
  loadingDeleteUser: false,
  loadingWantedList: false,
  wantedList: [],
  loadingAddToWanted: false,
  loadingDeleteFromWanted: false,
  loadingImportLPNFile: false,
  loadingCameraList: false,
  cameraList: [],
  loadingCreateCamera: false,
  loadingSaveCamera: false,
  loadingDeleteCamera: false,
  loadingWhiteList: false,
  whiteList: [],
  loadingAddToWhite: false,
  loadingDeleteFromWhiteList: false,
  loadingImportWhiteList: false,
  loadingViolationList: false,
  violationList: [],
  loadingAddToViolationList: false,
  loadingDeleteFromViolationList: false,
  loadingImportViolationList: false,
  loadingUserAction: false,
  userAction: [],
  loadingCalibrateCamera: false,
  loadingDefaultCollage: false,
  dateSettings: {},
  loadingDateSettings: false,
  dateStatus: {},
  loadingDateStatus: false,
  archiveSettings: {},
  loadingArchiveSettings: false,
  loadingSaveArchiveSettings: false,
  loadingSaveDateSettings: false,
  analystsSettings: {},
  loadingAnalystsSettings: false,
  loadingSaveAnalystsSettings: false,
  generalSettings: {},
  loadingGeneralSettings: false,
  loadingSaveGeneralSettings: false,
  loadingSaveExport: false,
  loadingUpdateExport: false,
};

const reducer = handleActions({
  ...createOperationStateReducer(SETTINGS_MODULE + SET_COMPASS, 'loadingSetCompass'),
  ...createOperationStateReducer(SETTINGS_MODULE + SET_GPS_MOD, 'loadingSetGpsMod'),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_PRESETS, 'presetsList', 'loadingPresetsList', []),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_PRESET, 'loadingSavePreset'),
  ...createOperationStateReducer(SETTINGS_MODULE + CREATE_PRESET, 'loadingAddPreset'),
  ...createOperationStateReducer(SETTINGS_MODULE + DELETE_PRESET, 'loadingDeletePreset'),
  ...createOperationStateReducerWithBegin(SETTINGS_MODULE + LOAD_PRESETS_COLLAGE, 'loadingPresetCollage'),
  ...createOperationStateReducer(SETTINGS_MODULE + CREATE_ROLE, 'loadingCreateRole'),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_ROLE, 'loadingSaveRole'),
  ...createOperationStateReducer(SETTINGS_MODULE + DELETE_ROLE, 'loadingDeleteRole'),
  ...createOperationStateReducer(SETTINGS_MODULE + CREATE_USER, 'loadingCreateUser'),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_USER, 'loadingSaveUser'),
  ...createOperationStateReducer(SETTINGS_MODULE + DELETE_USER, 'loadingDeleteUser'),
  ...createOperationStateReducer(SETTINGS_MODULE + ADD_LPN_TO_WANTED, 'loadingAddToWanted'),
  ...createOperationStateReducer(SETTINGS_MODULE + DELETE_FROM_WANTED, 'loadingDeleteFromWanted'),
  ...createOperationStateReducer(SETTINGS_MODULE + IMPORT_LPN_FILE, 'loadingImportLPNFile'),
  ...createLoadParameterReducer(SETTINGS_MODULE + LOAD_EXPORT, 'exportList', 'loadingExportList', []),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_USER_LIST, 'userList', 'loadingUserList', []),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_USER_ACTION, 'userAction', 'loadingUserAction', []),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_ROLE_LIST, 'roleList', 'loadingRoleList', []),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_WANTED_LIST, 'wantedList', 'loadingWantedList', []),
  ...createLoadParameterReducer(SETTINGS_MODULE + LOAD_CAMERAS, 'cameraList', 'loadingCameraList', []),
  ...createOperationStateReducer(SETTINGS_MODULE + CREATE_CAMERA, 'loadingCreateCamera'),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_CAMERA, 'loadingSaveCamera'),
  ...createOperationStateReducer(SETTINGS_MODULE + DELETE_CAMERA, 'loadingDeleteCamera'),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_WHITE_LIST, 'whiteList', 'loadingWhiteList', []),
  ...createOperationStateReducer(SETTINGS_MODULE + ADD_TO_WHITE_LIST, 'loadingAddToWhite'),
  ...createOperationStateReducer(SETTINGS_MODULE + DELETE_FROM_WHITE_LIST, 'loadingDeleteFromWhiteList'),
  ...createOperationStateReducer(SETTINGS_MODULE + IMPORT_WHITE_LIST, 'loadingImportWhiteList'),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_VIOLATION_LIST, 'violationList', 'loadingViolationList', []),
  ...createOperationStateReducer(SETTINGS_MODULE + ADD_TO_VIOLATION_LIST, 'loadingAddToViolationList'),
  ...createOperationStateReducer(SETTINGS_MODULE + DELETE_FROM_VIOLATION_LIST, 'loadingDeleteFromViolationList'),
  ...createOperationStateReducer(SETTINGS_MODULE + IMPORT_VIOLATION_LIST, 'loadingImportViolationList'),
  ...createOperationStateReducer(SETTINGS_MODULE + CALIBRATE_CAMERA, 'loadingCalibrateCamera'),
  ...createOperationStateReducer(SETTINGS_MODULE + GET_DEFAULT_COLLAGE, 'loadingDefaultCollage'),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_DATE_SETTINGS, 'dateSettings', 'loadingDateSettings'),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_DATE_STATUS, 'dateStatus', 'loadingDateStatus'),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_DATE_SETTINGS, 'loadingSaveDateSettings'),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_ARCHIVE_SETTINGS, 'archiveSettings', 'loadingArchiveSettings'),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_ARCHIVE_SETTINGS, 'loadingSaveArchiveSettings'),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_ARCHIVE_SETTINGS, 'archiveSettings', 'loadingArchiveSettings'),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_ARCHIVE_SETTINGS, 'loadingSaveArchiveSettings'),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_ANALYSTS_SETTINGS, 'analystsSettings', 'loadingAnalystsSettings'),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_ANALYSTS_SETTINGS, 'loadingSaveAnalystsSettings'),
  ...updateLoadParameterReducer(SETTINGS_MODULE + LOAD_GENERAL_SETTINGS, 'generalSettings', 'loadingGeneralSettings'),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_GENERAL_SETTINGS, 'loadingSaveGeneralSettings'),
  ...createOperationStateReducer(SETTINGS_MODULE + SAVE_EXPORT, 'loadingSaveExport'),
  ...createOperationStateReducer(SETTINGS_MODULE + UPDATE_EXPORT, 'loadingUpdateExport'),

  [SETTINGS_MODULE + UPDATE_CAMERA]: (state, action) => {
    const camera = action.payload;
    const cameraList = [...state.cameraList];
    const index = cameraList.findIndex(c => c.id === camera.id);
    if (index >= 0) {
      cameraList[index] = camera;
    }
    return {
      ...state,
      cameraList,
    };
  },
}, initialState);

export default reducer;

export const getSettingsData = createSelector(
  [state => state[SETTINGS_MODULE]],
  state => {
    const {
      loadingSetCompass,
      loadingSetGpsMod,
      loadingPresetsList,
      presetsList,
      loadingSavePreset,
      loadingAddPreset,
      loadingDeletePreset,
      loadingPresetCollage,
      loadingExportList,
      exportList,
      loadingUserList,
      userList,
      loadingRoleList,
      roleList,
      loadingCreateRole,
      loadingSaveRole,
      loadingDeleteRole,
      loadingCreateUser,
      loadingSaveUser,
      loadingDeleteUser,
      loadingWantedList,
      wantedList,
      loadingAddToWanted,
      loadingDeleteFromWanted,
      loadingImportLPNFile,
      loadingWhiteList,
      whiteList,
      loadingAddToWhite,
      loadingDeleteFromWhiteList,
      loadingImportWhiteList,
      loadingViolationList,
      violationList,
      loadingAddToViolationList,
      loadingDeleteFromViolationList,
      loadingImportViolationList,
      loadingUserAction,
      userAction,
      loadingCalibrateCamera,
      dateSettings,
      loadingDateSettings,
      dateStatus,
      loadingDateStatus,
      archiveSettings,
      loadingArchiveSettings,
      loadingSaveArchiveSettings,
      loadingSaveDateSettings,
      analystsSettings,
      loadingAnalystsSettings,
      loadingSaveAnalystsSettings,
      generalSettings,
      loadingGeneralSettings,
      loadingSaveGeneralSettings,
      loadingSaveExport,
      loadingUpdateExport,
    } = state;
    return {
      loadingSetCompass,
      loadingSetGpsMod,
      loadingPresetsList,
      presetsList,
      loadingSavePreset,
      loadingAddPreset,
      loadingDeletePreset,
      loadingPresetCollage,
      loadingExportList,
      exportList,
      loadingUserList,
      userList,
      loadingRoleList,
      roleList,
      loadingCreateRole,
      loadingSaveRole,
      loadingDeleteRole,
      loadingCreateUser,
      loadingSaveUser,
      loadingDeleteUser,
      loadingWantedList,
      wantedList,
      loadingAddToWanted,
      loadingDeleteFromWanted,
      loadingImportLPNFile,
      loadingWhiteList,
      whiteList,
      loadingAddToWhite,
      loadingDeleteFromWhiteList,
      loadingImportWhiteList,
      loadingViolationList,
      violationList,
      loadingAddToViolationList,
      loadingDeleteFromViolationList,
      loadingImportViolationList,
      loadingUserAction,
      userAction,
      loadingCalibrateCamera,
      dateSettings,
      loadingDateSettings,
      dateStatus,
      loadingDateStatus,
      archiveSettings,
      loadingArchiveSettings,
      loadingSaveArchiveSettings,
      loadingSaveDateSettings,
      analystsSettings,
      loadingAnalystsSettings,
      loadingSaveAnalystsSettings,
      generalSettings,
      loadingGeneralSettings,
      loadingSaveGeneralSettings,
      loadingSaveExport,
      loadingUpdateExport,
    };
  },
);

export const getCamerasData = createSelector(
  [state => state[SETTINGS_MODULE]],
  state => {
    const {
      loadingCameraList,
      cameraList,
      loadingCreateCamera,
      loadingSaveCamera,
      loadingDeleteCamera,
    } = state;
    return {
      loadingCameraList,
      cameraList,
      loadingCreateCamera,
      loadingSaveCamera,
      loadingDeleteCamera,
    };
  },
);
